import { render } from "./EditAsset.vue?vue&type=template&id=38a11ff4&scoped=true"
import script from "./EditAsset.vue?vue&type=script&lang=js"
export * from "./EditAsset.vue?vue&type=script&lang=js"

import "./EditAsset.vue?vue&type=style&index=0&id=38a11ff4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a11ff4"]])

export default __exports__